export default "__VITE_ASSET__x5ahbnxi__ 960w, __VITE_ASSET__CDaPyI66__ 1420w";